import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/rendez-vous/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentPicker"] */ "/vercel/path0/src/components/SliceMachine/NeumoContact/AppointmentPicker.tsx");
